<template>
	<div>
		<figure class="zanwu" v-if="!list || list.length===0">
			<img src="@/assets/kong.png" alt="" srcset="" />
			<figcaption>暂无数据</figcaption>
		</figure>
		<div v-for="(i,index) in list" :key="index" class="imglist">
			<div class="imglist1">
				<img :src="i.file" alt="" srcset="" />
				<div>
					<h3 v-if="lexing==0">{{index+1}}承认图</h3>
					<h3 v-if="lexing==1">{{index+1}}生产图</h3>
					<p>{{i.create_time}}</p>
				</div>
			</div>
			<span>查看</span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		props:{
			list:{
				type: Array,
				default: () => []
			},
			lexing:{
				type: Number,
				default: 0
			}
		},
		methods: {
			
		}
	}
	
	
</script>

<style scoped>
	.imglist{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		background-color:#E9ECF4;
		border-radius: 8px 8px 8px 8px;
		margin-top:12px;
		padding:12px;
		box-sizing: border-box;
	}
	.imglist1 img{
		width:42px;
		height:42px;
		border-radius:6px;
		margin-right:10px;
	}
	.imglist1{
		display:flex;
		align-items: center;
	}
	.imglist1 h3{
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
	}
	.imglist1 p{
		font-size: 12px;
		color: rgba(30,58,138,0.6);
	}
	.imglist span{
		font-weight: 400;
		font-size: 14px;
		color: #4297FF;
		cursor:pointer;
	}
	.zanwu{
		width:100%;
		text-align: center;
		padding:40px 0px;
	}
	.zanwu figcaption{
		font-size:14px;
		color:#999;
	}
	.zanwu img{
		width:180px;
		height:180px;
	}
</style>